// Actions
export const ALBUM_FETCH  = '[Album] Fetch'

// Mutations
export const ALBUM_META   = '[Album] meta'
export const ALBUM_OBTAIN = '[Album] obtain'
export const ALBUM_CLEAR  = '[Album] clear'
export const ALBUM_SET_LOADING = '[Album] set loading'
